import React, { createContext, useContext, useEffect, useState } from "react";
import { api, tokenStore } from "@/lib/api";

const AuthContext = createContext({ user: null, loading: true, login: async () => {}, logout: async () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Skip the /auth/me probe if we have no stored token AND no cookies could
    // possibly authenticate us — saves an unnecessary 401 on first paint.
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null)).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    // Persist the bearer token so subsequent requests work even if the
    // Set-Cookie header is stripped by the production proxy chain.
    if (r.data?.access_token) tokenStore.set(r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); }
    catch (err) {
      // 401 / network errors here are non-fatal — we still want to clear the
      // local token and bounce to login. Log for visibility.
      if (typeof console !== "undefined") console.warn("[auth] logout request failed:", err?.message || err);
    }
    tokenStore.clear();
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, loading, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
